/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import {PopulateAreaSpecificData} from '../areaContracts'

export const populateDetailedViewData: PopulateAreaSpecificData = async ({
  processService,
  auditEvents
}) => {
  const processIds = auditEvents
    .filter((auditEvent) => auditEvent.discriminator2)
    .map((auditEvent) => auditEvent.discriminator2)

  const processNames = await processService.getProcessNames(processIds as string[])

  auditEvents.forEach((auditEvent) => {
    if (auditEvent.discriminator2) {
      auditEvent.processName = processNames.get(auditEvent.discriminator2)
    }
  })
}
